import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import productDocumentService from "services/Setup/Organization/productDocumentService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  productDocumentDetail: {},
  productDocumentList: {},
};

export const getProductDocumentList = createAsyncThunk(
  "productDocument/getProductDocumentList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productDocumentService.getProductDocumentList(
        data
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getProductDocumentDetail = createAsyncThunk(
  "productDocument/getProductDocumentDetail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productDocumentService.getProductDocumentDetail(
        data
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postProductDocument = createAsyncThunk(
  "productDocument/postProductDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productDocumentService.postProductDocument(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateProductDocument = createAsyncThunk(
  "productDocument/updateProductDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productDocumentService.updateProductDocument(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteProductDocument = createAsyncThunk(
  "productDocument/deleteProductDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productDocumentService.deleteProductDocument(data);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const returnProductDocument = createAsyncThunk(
  "productDocument/returnProductDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productDocumentService.returnProductDocument(data);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const approveProductDocument = createAsyncThunk(
  "productDocument/approveProductDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productDocumentService.approveProductDocument(
        data
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const rejectProductDocument = createAsyncThunk(
  "productDocument/rejectProductDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productDocumentService.rejectProductDocument(data);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const requestProductDocument = createAsyncThunk(
  "productDocument/requestProductDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productDocumentService.requestProductDocument(
        data
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const productDocumentSlice = createSlice({
  name: "productDocument",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //list
      .addCase(getProductDocumentList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getProductDocumentList.fulfilled, (state, action) => {
        state.loading = false;
        state.productDocumentList = action.payload;
        console.log(
          "🚀 ~ .addCase ~ state.productDocumentList:",
          state.productDocumentList
        );
      })
      .addCase(getProductDocumentList.rejected, (state, action) => {
        state.loading = false;
        state.productDocumentDetail = action.payload;
        state.showMessage = true;
      })

      //detail
      .addCase(getProductDocumentDetail.pending, (state) => {
        if (state.productDocumentDetail == []) {
          state.loading = true;
        }
      })
      .addCase(getProductDocumentDetail.fulfilled, (state, action) => {
        if (state.productDocumentDetail == []) {
          state.loading = false;
        }
        state.productDocumentDetail = action.payload;
        console.log(
          "🚀 ~ .addCase ~ state.productDocumentDetail:",
          state.productDocumentDetail
        );
      })
      .addCase(getProductDocumentDetail.rejected, (state, action) => {
        if (state.productDocumentDetail == []) {
          state.loading = false;
        }
        state.productDocumentDetail = action.payload;
        state.showMessage = true;
      })

      //post
      .addCase(postProductDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(postProductDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        // state.productDocumentDetail = action.payload;
        // console.log(
        //   "🚀 ~ .addCase postProductDoc ~ action.payload:",
        //   action.payload
        // );
      })
      .addCase(postProductDocument.rejected, (state, action) => {
        state.loading = false;
        // state.productDocumentDetail = action.payload;
        state.showMessage = true;
      })

      //update
      .addCase(updateProductDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProductDocument.fulfilled, (state, action) => {
        // state.redirect = '/'
        state.loading = false;
        // state.productDocumentDetail = action.payload;
      })
      .addCase(updateProductDocument.rejected, (state, action) => {
        state.loading = false;
        // state.productDocumentDetail = action.payload;
        // state.showMessage = true;
      })

      //delete
      .addCase(deleteProductDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteProductDocument.fulfilled, (state, action) => {
        state.loading = false;
        // state.productDocumentDetail = action.payload;
        // console.log(
        //   "🚀 ~ .addCase deleteProductDoc ~ action.payload:",
        //   action.payload
        // );
      })
      .addCase(deleteProductDocument.rejected, (state, action) => {
        state.loading = false;
        // state.productDocumentDetail = action.payload;
        // state.showMessage = true;
      })

      // Return
      .addCase(returnProductDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(returnProductDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.productDocumentDetail = action.payload;
      })
      .addCase(returnProductDocument.rejected, (state, action) => {
        state.loading = false;
        state.productDocumentDetail = action.payload;
        state.showMessage = true;
      })

      // Approve
      .addCase(approveProductDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(approveProductDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.productDocumentDetail = action.payload;
      })
      .addCase(approveProductDocument.rejected, (state, action) => {
        state.loading = false;
        state.productDocumentDetail = action.payload;
        state.showMessage = true;
      })

      // Reject
      .addCase(rejectProductDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(rejectProductDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.productDocumentDetail = action.payload;
      })
      .addCase(rejectProductDocument.rejected, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
        state.showMessage = true;
      })

      // Request
      .addCase(requestProductDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(requestProductDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.productDocumentDetail = action.payload;
      })
      .addCase(requestProductDocument.rejected, (state, action) => {
        state.loading = false;
        state.productDocumentDetail = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  productDocumentSlice.actions;

export default productDocumentSlice.reducer;
